<app-calendario [titulo]="tituloMes" [diasDaSemana]="diasDaSemana" (mudarMes)="mudarMes($event)">
    <div
      class="calendario-dia"
      *ngFor="let dia of dias; trackBy: rastrearDia"
      [class.calendario-dia--outro-mes]="!dia.pertenceAoMes"
      [class.calendario-dia--hoje]="ehHoje(dia)"
      [class.calendario-dia--selecionado]="estaEditandoDia(dia)"
      (click)="iniciarNovoLembrete(dia)"
      role="gridcell">
      <div class="calendario-dia__cabecalho">
        <span class="calendario-dia__numero">{{ dia.data.getDate() }}</span>
      </div>
      <div class="calendario-dia__lembretes">
        <button
          *ngFor="let lembrete of lembretesDoDia(dia); trackBy: rastrearLembrete"
          matTooltip="{{ obterHorario(lembrete) }}"
          matTooltipPosition="above"
          type="button"
          class="lembrete-tag"
          [class.lembrete-tag--inativo]="!lembrete.blAtivo"
          (click)="editarLembrete(lembrete, $event)">
          {{ lembrete.dsLembrete }}
        </button>
      </div>
      <div
        class="lembrete-balao"
        [class.lembrete-balao--direita]="dia.data.getDay() > 3"
        [class.lembrete-balao--acima]="abrirBalaoParaCima(dia)"
        *ngIf="estaEditandoDia(dia) && lembreteEmEdicao"
        (click)="$event.stopPropagation()">
        <div class="lembrete-balao__titulo">{{ lembreteEmEdicao.id ? 'Editar lembrete' : 'Novo lembrete' }}</div>
        <div class="lembrete-balao__conteudo">
          <div class="lembrete-balao__campos">
            <mat-form-field appearance="fill">
              <mat-label>Descrição</mat-label>
              <input matInput maxlength="500" [(ngModel)]="lembreteEmEdicao.dsLembrete" [disabled]="!!lembreteEmEdicao.id && !data.podeAlterar(lembreteEmEdicao)">
            </mat-form-field>
            <div class="lembrete-balao__data-hora">
              <mat-form-field appearance="fill">
                <mat-label>Data</mat-label>
                <input matInput [matDatepicker]="picker" [(ngModel)]="lembreteEmEdicao.dtAgendadoData" [disabled]="!!lembreteEmEdicao.id && !data.podeAlterar(lembreteEmEdicao)">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Horário</mat-label>
                <input matInput type="text" maxlength="5" placeholder="00:00" [(ngModel)]="lembreteEmEdicao.hrAgendado" [disabled]="!!lembreteEmEdicao.id && !data.podeAlterar(lembreteEmEdicao)">
              </mat-form-field>
            </div>
          </div>
          <div class="lembrete-balao__preview" aria-label="Prévia da mensagem no WhatsApp">
            <div class="lembrete-balao__preview-titulo">{{ obterDataPreview(lembreteEmEdicao.dtAgendadoData) }}</div>
            <div class="lembrete-whatsapp-preview">
              <div class="lembrete-whatsapp-preview__mensagem">
                <span>⏰ {{ lembreteEmEdicao.dsLembrete.trim() || 'Sua mensagem aparecerá aqui' }}</span>
                <span class="lembrete-whatsapp-preview__horario">{{ lembreteEmEdicao.hrAgendado || '--:--' }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="lembrete-balao__acoes">
          <button mat-button type="button" (click)="$event.stopPropagation(); cancelarEdicao()">Cancelar</button>
          <button mat-button type="button" color="warn" *ngIf="textoAcaoAtivo" (click)="$event.stopPropagation(); alterarAtivo()">{{ textoAcaoAtivo }}</button>
          <button mat-button type="button" color="warn" *ngIf="lembreteSelecionado && data.podeExcluir(lembreteSelecionado)" (click)="$event.stopPropagation(); excluirLembrete()">Excluir</button>
          <button mat-raised-button type="button" color="primary" [disabled]="!podeSalvarEdicao()" (click)="$event.stopPropagation(); salvarEdicao()">Salvar</button>
        </div>
      </div>
    </div>
</app-calendario>
